/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/en-us'

import iconSet from 'quasar/icon-set/material-icons'


import Vue from 'vue'

import {Quasar,QFab,QFabAction,QIcon,QLayout,QPageContainer,QPage,QHeader,QPageSticky,QPageScroller,QToolbar,QToolbarTitle,QForm,QInput,QDialog,QTooltip,QBar,QBtnToggle,QImg,QCard,QCardSection,QCardActions,QAvatar,QTabs,QTab,QRouteTab,QCheckbox,QInfiniteScroll,QVideo,QChatMessage,ClosePopup,Cookies,LocalStorage,SessionStorage,Dialog,Notify,Meta} from 'quasar'


Vue.use(Quasar, { config: {},lang: lang,iconSet: iconSet,components: {QFab,QFabAction,QIcon,QLayout,QPageContainer,QPage,QHeader,QPageSticky,QPageScroller,QToolbar,QToolbarTitle,QForm,QInput,QDialog,QTooltip,QBar,QBtnToggle,QImg,QCard,QCardSection,QCardActions,QAvatar,QTabs,QTab,QRouteTab,QCheckbox,QInfiniteScroll,QVideo,QChatMessage},directives: {ClosePopup},plugins: {Cookies,LocalStorage,SessionStorage,Dialog,Notify,Meta} })
